"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }
var sortByPosition = function sortByPosition(categories) {
  categories.sort(function (submenuA, submenuB) {
    return submenuA.positionInColumn - submenuB.positionInColumn;
  });
};
var sortById = function sortById(categories) {
  categories.sort(function (submenuA, submenuB) {
    return submenuA.id - submenuB.id;
  });
};
var sortMenu = function sortMenu(menu) {
  menu.map(function (mainCategory) {
    var _global$__appConfig__;
    if (mainCategory.subcategories.length === 0) return;
    var columnsNumber = (_global$__appConfig__ = global.__appConfig__.menuColumnsNumber) !== null && _global$__appConfig__ !== void 0 ? _global$__appConfig__ : 4;
    var columnsInSubmenu = Array.from(Array(columnsNumber), function () {
      return [];
    });
    var categoriesWithUnsetColumnPosition = [];
    mainCategory.subcategories.forEach(function (subcategories) {
      sortByPosition(subcategories);
      subcategories.map(function (category) {
        return (category === null || category === void 0 ? void 0 : category.subcategories) && sortByPosition(category.subcategories);
      });
      subcategories.map(function (subcategory) {
        var _columnsInSubmenu;
        return (subcategory === null || subcategory === void 0 ? void 0 : subcategory.columnInMenu) && subcategory.columnInMenu !== 0 && (columnsInSubmenu === null || columnsInSubmenu === void 0 ? void 0 : (_columnsInSubmenu = columnsInSubmenu[subcategory.columnInMenu - 1]) === null || _columnsInSubmenu === void 0 ? void 0 : _columnsInSubmenu.push(subcategory));
      });
      categoriesWithUnsetColumnPosition = [].concat((0, _toConsumableArray2["default"])(categoriesWithUnsetColumnPosition), (0, _toConsumableArray2["default"])(subcategories.filter(function (subcategory) {
        return subcategory && subcategory.columnInMenu === 0;
      })));
      sortById(categoriesWithUnsetColumnPosition);
      categoriesWithUnsetColumnPosition.map(function (subcategory) {
        var _iterator = _createForOfIteratorHelper(columnsInSubmenu.entries()),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _step$value = (0, _slicedToArray2["default"])(_step.value, 2),
              index = _step$value[0],
              column = _step$value[1];
            if (column.length === 0 || index === columnsInSubmenu.length - 1) {
              column.push(subcategory);
              break;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    });
    mainCategory.subcategories = columnsInSubmenu;
    return mainCategory;
  });
  return menu;
};
var _default = sortMenu;
exports["default"] = _default;